import React from "react";
import PageTemplate from "@/components/templates/PageTemplate.jsx";
import AccountManagementContent from "@/components/organisms/AccountManagementContent.jsx";

function AccountManagement() {
  return (
    <PageTemplate
      title="Public Cloud Management"
      containerClassName="space-y-6"
    >
      <AccountManagementContent />
    </PageTemplate>
  );
}

export default AccountManagement;
